module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-users"
  }, [_c('v-layout', {
    staticClass: "row"
  }, [_c('v-flex', {
    staticClass: "mb-5"
  }, [_c('filter-bar', {
    attrs: {
      "search": _vm.search
    },
    on: {
      "filterUsers": function($event) {
        return _vm.filterUsers($event)
      },
      "search": function($event) {
        return _vm.searchFor($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "row"
  }, [_c('v-flex', {
    staticClass: "xs12"
  }, [_c('table', {
    staticClass: "fancy"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "line-num"
  }), _vm._v(" "), _c('th', {
    staticClass: "left-align"
  }, [_vm._v("Name / Company")]), _vm._v(" "), _c('th', {
    staticClass: "left-align"
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticClass: "left-align"
  }, [_vm._v("Role")]), _vm._v(" "), _c('th', {
    staticClass: "left-align"
  }, [_vm._v("Created")]), _vm._v(" "), _c('th', {
    staticClass: "left-align"
  }, [_vm._v("Updated")]), _vm._v(" "), _c('th', {
    staticClass: "left-align"
  }, [_vm._v("Last Log In")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [(_vm.users.length <= 0) ? _c('tr', [_c('td', {
    staticClass: "line-num"
  }), _vm._v(" "), _c('td', {
    staticClass: "center-align",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No users found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.users), function(user, index) {
    return _c('tr', {
      key: index
    }, [(!user.disabled_at) ? [_c('td', {
      staticClass: "line-num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(user.avatar_url) ? _c('v-avatar', {
      staticClass: "left mr-2",
      attrs: {
        "size": "30"
      }
    }, [_c('img', {
      attrs: {
        "src": user.avatar_url
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "username"
    }, [_vm._v(_vm._s(user.full_name) + " (" + _vm._s(user.id) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_vm._v(_vm._s(user.company_name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.role))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(user.created_at, 'MM/DD/YYYY hh:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(user.updated_at, 'MM/DD/YYYY hh:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(user.login_at, 'MM/DD/YYYY hh:mm')))]), _vm._v(" "), _c('td', {
      staticClass: "center-align no-wrap"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [(user.session_token) ? _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon",
        "href": '/?t=' + user.session_token,
        "target": "_blank"
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-login-variant")])], 1), _vm._v(" "), _c('span', [_vm._v("User Login")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon",
        "to": '/admin/users/' + user.id,
        "target": "_blank"
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('span', [_vm._v("Edit Profile")])], 1), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon"
      },
      on: {
        "click": function($event) {
          return _vm.disableUser(user.id)
        }
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-account-off")])], 1), _vm._v(" "), _c('span', [_vm._v("Disable User")])], 1), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "bottom"
      }
    }, [_c('v-menu', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": "icon"
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.features), function(feature) {
      return _c('v-list-tile', {
        key: feature.id,
        on: {
          "click": function($event) {
            return _vm.toggleFeature(user, feature.name)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": _vm.featureColor(user, feature.name)
        }
      }, [_vm._v(_vm._s(feature.icon))]), _vm._v(" \n"), _c('span', [_vm._v(_vm._s(feature.name))])], 1)
    }), 1)], 1), _vm._v(" "), _c('span', [_vm._v("Feature Flags")])], 1)], 1)])] : _vm._e()], 2)
  })], 2)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87a6ada4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=haml!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/users/index.vue
// module id = 656
// module chunks = 1